import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import type { EventProperties } from 'lumen/services/usage-analytics';
import { timeout } from 'lumen/utils/waiters';

interface GeneralTrackingTrackUsageAnalyticsHoverWrapperSignature {
  Args: {
    className?: string;
    eventName: string;
    properties: EventProperties;
  };
  Blocks: {
    default: [];
  };
}

export default class GeneralTrackingTrackUsageAnalyticsHoverWrapper extends Component<GeneralTrackingTrackUsageAnalyticsHoverWrapperSignature> {
  @service declare usageAnalytics: Services['usage-analytics'];

  trackHoverTask = task({ drop: true }, async (): Promise<void> => {
    await timeout('extra-long');

    this.usageAnalytics.track(this.args.eventName, this.args.properties);
  });

  @action onMouseEnter(): void {
    if (this.args.eventName) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.trackHoverTask.perform();
    } else {
      console.error(
        'You have used the hover tracking wrapper, but did not provide an eventName. Please provide an eventName',
      );
    }
  }

  @action onMouseLeave(): void {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.trackHoverTask.cancelAll();
  }

  <template>
    <div
      class={{@className}}
      role="tooltip"
      {{on "mouseenter" this.onMouseEnter}}
      {{on "mouseleave" this.onMouseLeave}}
    >
      {{yield}}
    </div>
  </template>
}
